define([], function() {
	var costcoWallet = {

			digitalWalletApplied: false,
			googleRecaptchaApi: null,
			displayShopCard: false,
			encryptionKeyUrl: null,
			balanceTransferUrl:null,
			merchantId: null,
			altMerchantId: null,
			orderId: null,
			currency: null,
			locale:'en_US',
			azureClientId: null,
			clientName: null,
			clientEnv: "PROD",
			balanceTransferStatus: false,
			formattedFundedAmount: null,
			paymentsHubPublicKey: null,
			paymentsHubAlgorithm: null,
			paymentsHubKeyId: null,
			
			validationRules : function() { 
				$.validator.addMethod("shopCardPin", function( value, element ) {
					return this.optional(element) || /^\d{4,8}$/.test(value);
				}, "Invalid PIN. Check your entry for accuracy and try again.");
				$.validator.addMethod("shopCardNumber", function( value, element ) {
					return this.optional(element) || /^\d{16}(\d{3})?$/.test(value.split(" ").join(""));
				}, "You have entered an invalid Shop Card number. Check entry for accuracy and try again.");
			},
			
			validate : {	
				shopCardBalanceTransferForm : function(form) {
					let shopCardPinError = messages.ERR_INVALID_CASHCARDPIN;
					let shopCardNumberError = messages.ERR_INVALID_CASHCARDNO;
					
					if($(form).length != 0) {
						$(form).validate({
							rules : { 
								shopCardNumber: { required:true, shopCardNumber:true},
								shopCardPin: { required:true, shopCardPin:true }
							},
							messages: {
								shopCardNumber: {required: shopCardNumberError, shopCardNumber: shopCardNumberError},
								shopCardPin:{required: shopCardPinError, shopCardPin: shopCardPinError},
							},
					        highlight: COSTCO.util.highlightWithErrorLabel,
					        unhighlight: COSTCO.util.unhighlightWithErrorLabel
						})
					}
					return $(form).valid();
				}
			},
			
			/**
			 * Method to add/remove Costco Wallet to Order
			 */		
			toggleUseDigitalWallet: function(applyDWObj){
				if(undefined == $("#dw-checkout-form input[name=piId]").val())
					return;				
				
				if(!$("#dw-checkout-form input[name=piId]").val()) {
					$("#dw-checkout-form input[name=action]").val('add');
					COSTCO.DigitalWallet.digitalWalletApplied = true;
					$("#shop-card-block").addClass("shop-card-block-select");
					COSTCO.DigitalWallet.addDigitalWallet();
					window.digitalDataEvents = window.digitalDataEvents || [];
					digitalDataEvents.push( { costcoBalance:"Checkout Flow | Toggle on" } );
				} else {
					$("#dw-checkout-form input[name=action]").val('remove');
					$("#shop-card-block").addClass("shop-card-block-deselect");				
					COSTCO.DigitalWallet.digitalWalletApplied = false;
					let walletPiId = $("#dw-checkout-form input[name=piId]").val();
					if(walletPiId != '')
						COSTCO.DigitalWallet.addDigitalWallet();
					window.digitalDataEvents = window.digitalDataEvents || [];
					digitalDataEvents.push( { costcoBalance:"Checkout Flow | Toggle Off" } );
				}
			},
			
			/**
			 * Method to add Costco Wallet PI
			 */
			addDigitalWallet: function(){
				if($('#dw-checkout-form').find('input[name=isPurchaseMembershipAutoRenew]').length > 0){
					let ftcAutoRenewConsentObj = COSTCO.CreditCard.forms.creditCardForm().find('input[name=isPurchaseMembershipAutoRenew]');
                	if(ftcAutoRenewConsentObj.length > 0)
                		$('#dw-checkout-form').find('input[name=isPurchaseMembershipAutoRenew]').val(ftcAutoRenewConsentObj.val());
				}
				COSTCO.Checkout.ajax_update_state({
			          error_container: '#dw-shop-card-error-container',
			          method: 'POST',
			          url: '/ManageDigitalShopCard',
			          data: $('#dw-checkout-form').serializeArray(),
			          dataType: 'json',
			          always: function(data, textStatus, jqXHR, options){
			        	  let application = data.error.application || [];
			        	  let exception = data.error.exception || [];
			        	  if(typeof COSTCO.CreditCard !== 'undefined'){
			          		  COSTCO.CreditCard.initComplete = false;
			        	  }
			        	  if(application.length > 0 || exception.length > 0 || !COSTCO.DigitalWallet.digitalWalletApplied){
			        		  $("#dw-checkout-form input[name=payment-digital-shopcard]").prop("checked", false);
			        	  }
			        	  if(data.error.itemNumber != undefined && data.error.itemNumber.length >0){
			        		  window.digitalDataEvents = window.digitalDataEvents || [];
			        		  digitalDataEvents.push({uimsg:"Checkout Flow| Payment Method | Costco Balance Updated"});
			        	  }
			        	  
			        	  TokenGateway.refreshGateway();
			        	  // handle balance transfer success message after adjusting wallet PiId
			        	  if(COSTCO.DigitalWallet.balanceTransferStatus && application.length == 0 && exception.length == 0){
			        		  let successMsg = $('#checkout-success-shop-card-applied').html();
			        		  successMsg = successMsg.replace("{0}", COSTCO.DigitalWallet.formattedFundedAmount);//
			        		  $('#checkout-success-shop-card-applied').html(successMsg);
			        		  $('#checkout-success-shop-card-container').removeClass('hide');
			        		  COSTCO.DigitalWallet.formattedFundedAmount = null;
			        		  COSTCO.DigitalWallet.balanceTransferStatus = false;
			        		  COSTCO.DigitalWallet.toggleSpinner('hide');
			        	  }
			          }
			        });
			},
			
			createReCaptchaScript: function() {
				const script = document.createElement('script');
				script.src = COSTCO.DigitalWallet.googleRecaptchaApi;
				script.async = true;
				script.defer = true;
				script.onload = () => {
					console.log('ReCaptcha script loaded successfully');
				};
				document.getElementById("addShopCard-input").appendChild(script);
			},
			
			executeReCaptcha: function(widgetId){
				if(undefined != widgetId) {
					grecaptcha.execute(widgetId);
				} else {
					grecaptcha.execute();
				}	
			},
			
			resetReCaptcha: function(widgetId) {
				if(undefined != widgetId) {
					grecaptcha.reset(widgetId);
				} else {
					grecaptcha.reset();
				}	
			},

			/**
			 * Method to show/hide Add Shop Card section for transferring funds
			 */
			toggleAddShopCardForm: function(action) {				
				if('hide' == action) {
					$("#addShopCardSubModuleContainer").addClass('hide');
					$("#addShopCardContainer").removeClass('hide');
				} else {
					$('#dwShopCardNumber').val('');
					$('#dwShopCardPin').val('');					
					$("#addShopCardSubModuleContainer").removeClass('hide');
					$("#addShopCardContainer").addClass('hide');
					$('#checkout-success-shop-card-container').addClass('hide');
					$('#load-limit-disclaimer').focus();
					
					if(costcoStoreFeatures.RECAPTCHA_VALIDATION_ENABLED !== 'undefined' && costcoStoreFeatures.RECAPTCHA_VALIDATION_ENABLED) {
						COSTCO.DigitalWallet.createReCaptchaScript();						
						$('#recaptcha-text-modal').removeClass("hide");					
					}
					COSTCO.DigitalWallet.clearShopCardErrors();
				}
			},
			
			/**
			 * Method to clear all error messages and respective classes
			 */
			clearShopCardErrors: function () {
		    	$("[id=dwShopCardNumber]").removeClass('error');
				$("[id=dwShopCardNumber-error]").hide();
				$("[id=dwShopCardNumber-error]").text('');
				
				$("[id=dwShopCardPin]").removeClass('error');
				$("[id=dwShopCardPin-error]").hide();
				$("[id=dwShopCardPin-error]").text('');
				
				$('#addShopCard-error-container').addClass('hide');
		    },
		    
		    /**
		     * Method to display error messages during fund trasnfer flow
		     */
		    handleWalletTransferError: function(errorMessage, showEspotContainer) {
				
				if(undefined != showEspotContainer && showEspotContainer) {
					$('#addShopCard-error-container > #loadLimitError').removeClass('hide');
					$('#addShopCard-error-container > #genericshopcardError').addClass('hide');
				} else {
					$('#addShopCard-error-container > #genericshopcardError').html(errorMessage);
					$('#addShopCard-error-container > #genericshopcardError').removeClass('hide');
					$('#addShopCard-error-container > #loadLimitError').addClass('hide');
				}
				
				$('#addShopCard-error-container').removeClass('hide');
				COSTCO.DigitalWallet.toggleSpinner('hide');
			},
			
			/**
			 * Method to show/hide spinner
			 */
			toggleSpinner: function(action) {
				if('hide' == action) {
					$('#shopCardSpinner').addClass('hidden');
		            $('#addShopCardSubModuleContainer').removeClass('ajax-busy');
				} else {
					$('#shopCardSpinner').removeClass('hidden');
					//$('#loading-spinner').removeClass('hidden');
		            $('#addShopCardSubModuleContainer').addClass('ajax-busy');
				}
			},			
			
			
			/**
			 * Method to transfer funds to Costco Wallet
			 */
			addShopCard: function() {
				if (COSTCO.DigitalWallet.validate.shopCardBalanceTransferForm($('#add-shopCard-form'))) {
					
					if(null == COSTCO.DigitalWallet.encryptionKeyUrl || null == COSTCO.DigitalWallet.balanceTransferUrl 
													|| null == COSTCO.DigitalWallet.merchantId || null == COSTCO.DigitalWallet.orderId
																							|| null == COSTCO.DigitalWallet.altMerchantId) {
						console.log('one of xapp params is invalid.');
						COSTCO.DigitalWallet.handleWalletTransferError(messages.CASHCARD_CHECK_BALANCE_ERROR);
						return;
					}
					
					let isPayhubApigeeEnabled = ($('#add-shopCard-form #isPayhubApigeeEnabled').length > 0 && $('#add-shopCard-form #isPayhubApigeeEnabled').val() == "true") ? true : false;
					
					if(isPayhubApigeeEnabled) {
						if(null == COSTCO.DigitalWallet.paymentsHubPublicKey || null == COSTCO.DigitalWallet.paymentsHubAlgorithm || null == COSTCO.DigitalWallet.paymentsHubKeyId) {
							// gets user JWT token
				            let userToken = COSTCO.DigitalWallet.getUserToken();		            
							
							if(null != userToken) {
								// gets public key to encrypt shop card number & pin
								let encryptionKeyResponse = COSTCO.DigitalWallet.getWalletEncryptionKey(userToken);
								COSTCO.DigitalWallet.paymentsHubPublicKey = encryptionKeyResponse.publicKey;
								COSTCO.DigitalWallet.paymentsHubAlgorithm = encryptionKeyResponse.algorithm;
								COSTCO.DigitalWallet.paymentsHubKeyId = encryptionKeyResponse.id;
							}
						}
						
						let shopCardNumber = $('#dwShopCardNumber').val().split(" ").join("");
						let encryptedCardNo = COSTCO.DigitalWallet.encryptField(shopCardNumber, COSTCO.DigitalWallet.paymentsHubKeyId,
																						COSTCO.DigitalWallet.paymentsHubPublicKey, COSTCO.DigitalWallet.paymentsHubAlgorithm);
		
						let encryptedPin = COSTCO.DigitalWallet.encryptField($('#dwShopCardPin').val(), COSTCO.DigitalWallet.paymentsHubKeyId,
																						COSTCO.DigitalWallet.paymentsHubPublicKey, COSTCO.DigitalWallet.paymentsHubAlgorithm);
						
						$("#add-shopCard-form input[name=encryptedCashCardNumber]").val("ENC_["+encryptedCardNo+"]");
						$("#add-shopCard-form input[name=encryptedCashCardPin]").val("ENC_["+encryptedPin+"]");
						
						if($("#add-shopCard-form input[name=cardLastFour]").length > 0){
							$($("#add-shopCard-form input[name=cardLastFour]")).val(shopCardNumber.slice(-4));
						}
						
						$('#add-shopCard-form #dwShopCardNumber').prop("disabled", true);
						$('#add-shopCard-form #dwShopCardPin').prop("disabled", true);
		
						COSTCO.Checkout.ajax_update_state({
					          error_container: '#genericshopcardError',
					          method: 'POST',
					          url: '/AjaxTransferShopCardFunds',
					          data: $('#add-shopCard-form').serializeArray(),
					          dataType: 'json',
					          always: function(data, textStatus, jqXHR, options){
					        	  if(undefined != data.balanceTransferResponse && data.balanceTransferResponse.trim().length > 0) {
					        		  COSTCO.DigitalWallet.processTransferFundsResponse(JSON.parse(data.balanceTransferResponse));
					        	  } else {
					        		  COSTCO.DigitalWallet.handleWalletTransferError(messages.CASHCARD_CHECK_BALANCE_ERROR);
					        	  }
					        	  
					        	  COSTCO.DigitalWallet.toggleSpinner('hide');
					        	  $('#add-shopCard-form #dwShopCardNumber').prop("disabled", false);
								  $('#add-shopCard-form #dwShopCardPin').prop("disabled", false);
					          }
					        });
					} else {
						// gets user JWT token
			            let userToken = COSTCO.DigitalWallet.getUserToken();		            
						
						if(null != userToken) {
							// gets public key to encrypt shop card number & pin
							let encryptionKeyResponse = COSTCO.DigitalWallet.getWalletEncryptionKey(userToken);
							
							if(null != encryptionKeyResponse) {
								let shopCardNumber = $('#dwShopCardNumber').val().split(" ").join("");
								let encryptedCardNo = COSTCO.DigitalWallet.encryptField(shopCardNumber, encryptionKeyResponse.id,
																									encryptionKeyResponse.publicKey, encryptionKeyResponse.algorithm);

								let encryptedPin = COSTCO.DigitalWallet.encryptField($('#dwShopCardPin').val(), encryptionKeyResponse.id,
																									encryptionKeyResponse.publicKey, encryptionKeyResponse.algorithm);
								// transfers funds to Costco Wallet
								let transferFundsResponse = COSTCO.DigitalWallet.trasnferShopCardFunds(userToken, encryptedCardNo, encryptedPin, shopCardNumber);
								
								if(null != transferFundsResponse){
									COSTCO.DigitalWallet.processTransferFundsResponse(transferFundsResponse);
									
								} else {
									COSTCO.DigitalWallet.handleWalletTransferError(messages.CASHCARD_CHECK_BALANCE_ERROR);
								}							
							} else {
								COSTCO.DigitalWallet.handleWalletTransferError(messages.CASHCARD_CHECK_BALANCE_ERROR);
							}
						} else {
							COSTCO.DigitalWallet.handleWalletTransferError(messages.CASHCARD_CHECK_BALANCE_ERROR);
						}
					}
				} else{
					COSTCO.DigitalWallet.toggleSpinner('hide');
				}
			},
			
			/**
			 * Method to process /balance-transfer api response
			 * 
			 * error code 27: GOM card applied which is not supported
			 * error code 17/18: Load limit reached error  
			 * 
			 * on Success, display amount loaded and Costco Wallet available balance
			 * 
			 */
			processTransferFundsResponse: function(transferFundsResponse) {
				if(undefined == transferFundsResponse || null == transferFundsResponse || transferFundsResponse == "")
					return;
				
				if('Success' == transferFundsResponse.paymentsHubTransactionResultCode) {
					
					let currencyFormatLocale = COSTCO.DigitalWallet.locale.replace('_','-');
					let currencyFormatter = Intl.NumberFormat(currencyFormatLocale, 
													{ style: "currency", currency: COSTCO.DigitalWallet.currency });
					
					let totalFundedAmount = transferFundsResponse.totalFundedAmount.amount;
					let formattedFundedAmount = currencyFormatter.format(totalFundedAmount);
					if(formattedFundedAmount.indexOf('CA') != -1) { 
						formattedFundedAmount = formattedFundedAmount.replace('CA', '');
					};
					let successMsg = $('#checkout-success-shop-card-applied').html();
					successMsg = successMsg.replace("{0}", formattedFundedAmount);
					$('#checkout-success-shop-card-applied').html(successMsg);
					COSTCO.DigitalWallet.formattedFundedAmount = formattedFundedAmount;
					
					window.digitalDataEvents = window.digitalDataEvents || [];
					digitalDataEvents.push({uimsg:"Checkout Flow| Wallet | Costco Balance | Add Shop Card | Success",
						countBalance: "1", dollarBalance:totalFundedAmount});
					
					
					let availableBalanceFromShopCardBucket = null;
					let walletStoredValueBucketBalances = transferFundsResponse.walletStoredValueBalances.walletStoredValueBucketBalances;
					let availableBalance = 0;
					for(var i=0; i < walletStoredValueBucketBalances.length; i++) {
						if(walletStoredValueBucketBalances[i].bucket == 'ShopCard') {
							availableBalanceFromShopCardBucket = currencyFormatter.format(walletStoredValueBucketBalances[i].availableBalance.amount);
							availableBalance = walletStoredValueBucketBalances[i].availableBalance.amount;
							break;
						}
					}
					if(null != availableBalanceFromShopCardBucket) {
						$('#balance-label').html(availableBalanceFromShopCardBucket+' available');
					}
					
					if(availableBalance > 0 && COSTCO.DigitalWallet.digitalWalletApplied) {
						COSTCO.DigitalWallet.balanceTransferStatus = true;
						COSTCO.DigitalWallet.addDigitalWallet();
					} else {
						$('#checkout-success-shop-card-container').removeClass('hide');
						COSTCO.DigitalWallet.toggleAddShopCardForm('hide');
						COSTCO.DigitalWallet.toggleSpinner('hide');
					}
				} else {
					let errorInfoJSON = JSON.parse(transferFundsResponse.responses[0].gatewayErrorInformation);
					if(undefined != errorInfoJSON.hostExtraInfo) {
						for(var i=0; i < errorInfoJSON.hostExtraInfo.length; i++) {
							if(errorInfoJSON.hostExtraInfo[i].name == 'HOST_RESPONSE_CODE') {
								let errorCode = errorInfoJSON.hostExtraInfo[i].value;
								if('17' == errorCode || '18' == errorCode) {
									window.digitalDataEvents = window.digitalDataEvents || [];
									digitalDataEvents.push({uimsg:"Checkout Flow| Wallet | Costco Balance | Add Shop Card |  Error | Max Limit "});
									COSTCO.DigitalWallet.handleWalletTransferError(null, true);
									break;
								} else if ('27' == errorCode) {
									window.digitalDataEvents = window.digitalDataEvents || [];
									digitalDataEvents.push({uimsg:"Checkout Flow| Wallet | Costco Balance | Add Shop Card | Error | Gift of Membership Not Accepted"});
									COSTCO.DigitalWallet.handleWalletTransferError(messages.RWD_CHECKOUT_ERROR_ADD_SHOP_CARD);
									break;
								} else if ('01' == errorCode) {
									window.digitalDataEvents = window.digitalDataEvents || [];
									digitalDataEvents.push({uimsg:"Checkout Flow| Wallet | Costco Balance | Add Shop Card | Error | Inefficent Balance"});
									COSTCO.DigitalWallet.handleWalletTransferError(messages.RWD_CHECKOUT_ERROR_INSUFFICIENT_FUNDS);
									break;
								} else {
									COSTCO.DigitalWallet.handleWalletTransferError(messages.CASHCARD_CHECK_BALANCE_ERROR);
									window.digitalDataEvents = window.digitalDataEvents || [];
									digitalDataEvents.push({uimsg:"Checkout Flow| Wallet | Costco Balance | Add Shop Card |  Error | " + errorInfoJSON.message});
									break;
								}
							}
						}
					} else {
						COSTCO.DigitalWallet.handleWalletTransferError(messages.CASHCARD_CHECK_BALANCE_ERROR);
						window.digitalDataEvents = window.digitalDataEvents || [];
						digitalDataEvents.push({uimsg:"Checkout Flow| Wallet | Costco Balance | Add Shop Card |  Error | " + errorInfoJSON.message});						
					}
					
					console.log('transfer funds response error message: '+errorInfoJSON.message);
				}
			},
			
			/**
			 * Method to initiate /balance-transfer Digital labs api
			 */
			trasnferShopCardFunds: function(userToken, encryptedCardNo, encryptedPin, shopCardNumber) {
				
				if(undefined == userToken || undefined == encryptedCardNo 
						|| undefined == encryptedPin || null == COSTCO.DigitalWallet.balanceTransferUrl)
					return null;
				
				let transferFundsResponse = null;
				
				let transferFundsParams = {
					merchantTransactionId		: (COSTCO.DigitalWallet.orderId+ Date.now()).substring(0,20),
					merchantId					: COSTCO.DigitalWallet.merchantId,
					altMerchantId				: COSTCO.DigitalWallet.altMerchantId,
					orderId						: COSTCO.DigitalWallet.orderId,
					sourceShopCardNumber		: "ENC_["+encryptedCardNo+"]",
					sourceShopCardSecurityCode	: "ENC_["+encryptedPin+"]",
					bucket						: "ShopCard",
					transactionDescription		: "Shop Card "+shopCardNumber.slice(-4)+" Balance Check",
					replayCount					: 0,
					fundAmount : {
					    currency: COSTCO.DigitalWallet.currency,
					    amount: 0
					}
				};
				
				let headers = {
		        	Authorization				: userToken,
		        	"Costco-Env" 				: COSTCO.DigitalWallet.clientEnv,
		        	"Costco-X-Wcs-Clientid"		: COSTCO.DigitalWallet.azureClientId,
		        	"Costco-Sending-Application": COSTCO.DigitalWallet.clientName
		         };
				
				transferFundsResponse = COSTCO.DigitalWallet.callAjaxService('POST', COSTCO.DigitalWallet.balanceTransferUrl,
																										headers, transferFundsParams);
				
				return transferFundsResponse;
			},
			
			/**
			 * Method to get user JWT token
			 */
			getUserToken: function() {
				let userIdToken = null;
				
				let tokenResponse = COSTCO.DigitalWallet.callAjaxService('GET', '/gettoken', null, null);
				
				if(null != tokenResponse && tokenResponse.has_logged_in && undefined != tokenResponse.id_token) {
            		userIdToken = tokenResponse.id_token;
            	} 
				
		    	return userIdToken;
		    },
			
		    /**
		     * Method to generate /ecryptionkey Digital Labs api for publicKey
		     */
			getWalletEncryptionKey: function(id_token) {
				
				let encryptionKeyResponse = null;
				
				if(undefined != id_token && null != COSTCO.DigitalWallet.encryptionKeyUrl) {
					let headers = { Authorization: id_token };
					
					let response = COSTCO.DigitalWallet.callAjaxService('GET', 
											COSTCO.DigitalWallet.encryptionKeyUrl, headers, null);
					
					if(null != response && undefined != response.id && undefined != response.publicKey) {
                		encryptionKeyResponse = response
                	}
				}
				
				return encryptionKeyResponse;
			},
			
			/**
			 * JQuery Ajax service
			 */
			callAjaxService: function(httpMethod, serviceUrl, headers, data) {
				
				if((undefined == serviceUrl || null == serviceUrl || serviceUrl == "") 
						|| (undefined == httpMethod  || null == httpMethod || httpMethod == ""))
					return null;
				
				let serviceResponse = null;
				$.ajax({
			        url: serviceUrl,
			        type: httpMethod,
			        dataType: 'json',
			        global: false,
		            async: false,
		            contentType: 'application/json',
			        data: (undefined != data && "" != data) ? JSON.stringify(data) : {},
			        headers: (undefined != headers && "" != headers) ? headers : {},
			        success: function (response) {
			        	console.log('response: '+response);
			        	serviceResponse = response;
	                },
	                error: function (errorResponse) {
	                    console.log(errorResponse);
	                }, 
	                complete: function(request, status){
	                	console.log('complete: '+status);
	                }
			    });
				
				return serviceResponse;
			},
			
			/**
			 * Method to encrypt the shop card and pin with publicKey using forge library
			 */
			encryptField: function (payload, keyId, publicKey, algorithm) {
				   
			    // create JWE Protected Header
			    var jweProtectedHeaderObj = {
			        "alg": algorithm, 
			        "enc": "A256GCM", 
			        "kid": keyId,
			        "typ": "JWT" //this JWE is a JWT
			    };
			    
			    var jweProtectedHeaderJsonString = JSON.stringify(jweProtectedHeaderObj); 
			    var jweProtectedHeaderUtf8 = window.forge.util.encodeUtf8(jweProtectedHeaderJsonString); 
			    var jweProtectedHeaderBase64UrlEncoded = COSTCO.DigitalWallet.base64url_encode(jweProtectedHeaderUtf8); 

			    // generate a one-time-use random Content Encryption Key (CEK) and initialization vector (IV)
			    var contentEncryptionKeyBytes = window.forge.random.getBytesSync(32);
			    var initializationVectorBytes = window.forge.random.getBytesSync(12); 
			    var initializationVectorBase64UrlEncoded = COSTCO.DigitalWallet.base64url_encode(initializationVectorBytes); 

			    //encrypt the CEK using the recipient's (Payments Hub's) public key using RSA-OAEP-256
			    var publicKeyBytes = window.forge.util.decode64(publicKey); 
			    var rsaPublicKeyAsn1 = window.forge.asn1.fromDer(publicKeyBytes, false); //the recipient's public key will be a DER encoded ASN.1 PKCS#1 RsaPublicKey
			    var rsaPublicKeyObj = window.forge.pki.publicKeyFromAsn1(rsaPublicKeyAsn1); //from the ASN.1 object, create an instance of the recipient public key 
			    var encryptedContentEncryptionKeyBytes = rsaPublicKeyObj.encrypt(contentEncryptionKeyBytes, 'RSA-OAEP', {
			        md: window.forge.md.sha256.create()
			    }); //encrypt the one-time-use Content Encryption Key (CEK) with the recipient's public key
			    var encryptedContentEncryptionKeyBase64UrlEncoded = COSTCO.DigitalWallet.base64url_encode(encryptedContentEncryptionKeyBytes); 

			    // encrypt the payload (secret) using AES-256 in GCM mode using the one-time-use Content Encryption Key (CEK) generated earlier
			    var cipher = window.forge.cipher.createCipher('AES-GCM', contentEncryptionKeyBytes);
			    cipher.start({ iv: initializationVectorBytes, additionalData: jweProtectedHeaderBase64UrlEncoded, tagLength: 128 });
			    cipher.update(window.forge.util.createBuffer(payload));
			    cipher.finish();
			    var ciphertextBytes = cipher.output; 
			    var ciphertextBase64UrlEncoded = COSTCO.DigitalWallet.base64url_encode(ciphertextBytes.getBytes());  
			    var authenticationTagBytes = cipher.mode.tag; 
			    var authenticationTagBase64UrlEncoded = COSTCO.DigitalWallet.base64url_encode(authenticationTagBytes.getBytes()); 

			    //build the JWE from its components
			    var jwe = jweProtectedHeaderBase64UrlEncoded + "." + encryptedContentEncryptionKeyBase64UrlEncoded + "." 
			    				+ initializationVectorBase64UrlEncoded + "." + ciphertextBase64UrlEncoded + "." + authenticationTagBase64UrlEncoded;
			    console.debug(payload+' jwe: '+jwe)
			    //return the JWE containing the encrypted content
			    return jwe;
			},

			base64url_encode: function (input) {
			    //Base64URL encoding is Base64 encoding with certain problematic characters and end-padding replaced with alternate characters.
				//JWE requires Base64URL encoding to be used for all JWE fields.  Here we just augment Forge's standard Base64 encoding with the Base64URL encoding additional behavior
			    var base64String = window.forge.util.encode64(input);
			    var output = base64String.replace(/=+$/, '');
			    output = output.replace(/\+/g, '-');
			    output = output.replace(/\//g, '_');
			    return output;
			},
			
			formatCard: function(cardObject) {
				if(undefined == cardObject)
					return;
				
				 var cardInput = $(cardObject).val().split(" ").join(""); // remove spaces
				 cardInput = cardInput.replace(/[^0-9]/g, '');
				  if (cardInput.length > 0) {
					  cardInput = cardInput.match(new RegExp('.{1,4}', 'g')).join(" ");
				  }
				  $(cardObject).val(cardInput);
			},
			
			toggleCashCardPinVisibility: function(){	
				if($('#eyeIconCashCardPin').html() == 'visibility'){
					$('#eyeIconCashCardPin').html('visibility_off');
					$('#dwShopCardPin').attr('type', 'text');
					$('#eyeIconCashCardPin').attr('aria-pressed', 'true');
					$('#eyeIconCashCardPin').attr('aria-label', 'Hide Pin');
				} else{
					$('#eyeIconCashCardPin').html('visibility');
					$('#dwShopCardPin').attr('type', 'password');
					$('#eyeIconCashCardPin').attr('aria-pressed', 'false');
					$('#eyeIconCashCardPin').attr('aria-label', 'Show Pin');
				}
			}
	};

	if (typeof window.COSTCO === 'undefined') {
		window.COSTCO = {};
	} 
    window.COSTCO.DigitalWallet = costcoWallet;
    costcoWallet.validationRules();
    return costcoWallet;
});


// WEBPACK FOOTER //
// ./js/checkout/costcoWallet.js